import { ResetPasswordDialogComponent } from './../reset-password-dialog/reset-password-dialog.component';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './../../../@resources/services/auth.service';
import { AccountService } from '../../../@resources/services/account.service';
import { SettingService } from '../../../@resources/services/setting.service';
import { ServiceService } from '../../../@resources/services/service.service';
import { LocalStorageService } from '../../../@resources/services/local-storage.service';
import { Global } from '../../../@core/global/global';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  HostListener,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaginationOptions } from '../../../@resources/graphql/types/types';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AuthDialogComponent } from '../auth-dialog/auth-dialog.component';
import { CartService } from 'src/app/@shared/services/cart/cart.service';
import { Product } from 'src/app/@shared/types/products';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  currentLang: any;
  paginationOptions: PaginationOptions = { limit: 0, page: 1 };
  cartId: string = '';

  @Output() public sidenavToggle = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    public global: Global,
    private serviceService: ServiceService,
    private localStorage: LocalStorageService,
    @Inject(DOCUMENT) private _document: Document,
    private translate: TranslateService,
    private settingService: SettingService,
    private accountService: AccountService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private cartService: CartService,
    private router: Router
  ) {
    this.switchLang(
      this.localStorage.get('lang') ? this.localStorage.get('lang') : 'ar'
    );
  }
  cartItems: Product[] = [];
  cart: any;
  showCart = false;
  count: number = this.cartService.count;
  ngOnInit(): void {
    this.getcartItmes();
    // console.log(this.cartId)
    this.cartService.cartUpdates$.subscribe(() => {
      this.count = this.cartService.count;
      this.cartItems = this.cartService.cartItmes;
      this.cart = this.cartService.cartInfo;
    });
    this.getLang();
    this.listService();
    this.listSetting();
    // this.validateCustomerToken()
    if (this.localStorage.get('TOKEN')) {
      this.customer();
      this.global.authenticated = true;
    } else {
      this.global.authenticated = false;
    }
    this.authService.loginDialog.subscribe((res) => {
      if (res) {
        this.openDialog();
      }
    });

    this.route.queryParams
      .pipe(filter((params: any) => params))
      .subscribe((params) => {
        if (params?.email && params?.token) {
          this.openResetPasswordDialog(params);
        }
      });
  }
  // headerfixed: boolean = false;
  // @HostListener('window:scroll', ['$event']) onScroll() {
  //   let prevScrollpos: any = window.pageYOffset;
  //   const header = document.getElementById('header') as HTMLInputElement;
  //   if (prevScrollpos > currentScrollpos) {
  //     header.style.top = '0';
  //   } else {
  //     header.style.top = '-220px';
  //   }
  //   prevScrollpos = currentScrollpos;
  // }
  showCartFun() {
    this.showCart = !this.showCart;
    this.cartService.getCartItems().subscribe(({ data }) => {
      this.cartItems = data.cart.items;
    });
    this.cart = this.cartService.cartInfo;
  }
  openDialog() {
    const dialogRef = this.dialog.open(AuthDialogComponent, {
      autoFocus: false,
    });
  }

  goToCart() {
    this.showCart = false;
    this.router.navigate(['/cart']);
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  };

  getcartItmes() {
    let cartId =
      localStorage.getItem('amandaCartId') ||
      localStorage.getItem('amandaClientCartId');
    if (!cartId) {
      this.cartService.createCart();
      cartId =
        localStorage.getItem('amandaClientCartId') ||
        this.cartService.cartInfo?.cartId ||
        '';
    }
    this.cartId = cartId;
    this.cartService.getCartItems();
  }

  listService() {
    this.serviceService
      .listServices(this.paginationOptions)
      .subscribe((res: any) => {
        this.global.services = res.data.services;
        this.count = this.cartService.count;
      });
  }

  listSetting() {
    this.settingService.listSetting().subscribe(({ data }) => {
      this.global.setting = data['setting'];
    });
  }

  changeLang(lang: any) {
    this.localStorage.remove('lang');
    this.localStorage.set('lang', lang);
    this.global.lang = lang;
    this.refreshPage();
  }

  deleteItem(cartItemId: string) {
    this.cartService.deleteCartItem(cartItemId, this.cartId);
  }

  clearCart() {
    this.cartService.clearCart(this.cartId);
  }

  getLang() {
    if (this.localStorage.get('lang')) {
      this.currentLang = this.localStorage.get('lang');
    } else {
      this.currentLang = 'ar';
      this.localStorage.set('lang', 'ar');
    }
  }

  refreshPage() {
    this._document.defaultView!.location.reload();
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    this.global.lang = lang;
  }

  // validateCustomerToken(){
  //   this.accountService.validateCustomerToken().subscribe((res:any) =>{
  //   })
  // }

  customer() {
    this.localStorage.get('CUSTOMER');
  }

  openResetPasswordDialog(params: any) {
    const dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
      data: { ...params },
    });
  }
}
